import { BorderRadiusTokens, ButtonTypeTokens, ColorTokens, FontSizeTokens, ShadowTypeTokens, SizeTypeTokens, } from '@voltmoney/schema';
export const buttonTypeTokensMap = {
    [ButtonTypeTokens.GoogleLargeFilled]: {
        borderRadius: BorderRadiusTokens.BR1,
        labelColor: ColorTokens.White,
        bgColor: ColorTokens.Google,
        paddingVertical: SizeTypeTokens.XS,
        fontSize: FontSizeTokens.LG,
        paddingHorizontal: SizeTypeTokens.XS,
    },
    [ButtonTypeTokens.LargeFilled]: {
        borderRadius: BorderRadiusTokens.BR5,
        labelColor: ColorTokens.White,
        bgColor: ColorTokens.Primary_100,
        paddingVertical: SizeTypeTokens.LG,
        fontSize: FontSizeTokens.LG,
        paddingHorizontal: SizeTypeTokens.XXXXL,
    },
    [ButtonTypeTokens.MediumFilled]: {
        borderRadius: BorderRadiusTokens.BR5,
        labelColor: ColorTokens.White,
        bgColor: ColorTokens.Primary_100,
        paddingVertical: SizeTypeTokens.MD,
        fontSize: FontSizeTokens.MD,
        paddingHorizontal: SizeTypeTokens.XXXL,
    },
    [ButtonTypeTokens.SmallFilled]: {
        borderRadius: BorderRadiusTokens.BR5,
        labelColor: ColorTokens.White,
        bgColor: ColorTokens.Primary_100,
        paddingVertical: SizeTypeTokens.SM,
        fontSize: FontSizeTokens.SM,
        paddingHorizontal: SizeTypeTokens.XL,
    },
    [ButtonTypeTokens.IconFilled]: {
        borderRadius: BorderRadiusTokens.BR5,
        labelColor: ColorTokens.White,
        bgColor: ColorTokens.Primary_100,
        paddingVertical: SizeTypeTokens.LG,
        paddingHorizontal: SizeTypeTokens.LG,
    },
    [ButtonTypeTokens.LargeSoftFilled]: {
        borderRadius: BorderRadiusTokens.BR5,
        labelColor: ColorTokens.Primary_100,
        bgColor: ColorTokens.White,
        borderColor: ColorTokens.Primary_100,
        paddingVertical: SizeTypeTokens.LG,
        fontSize: FontSizeTokens.LG,
        paddingHorizontal: SizeTypeTokens.XXXXL,
    },
    [ButtonTypeTokens.MediumSoftFilled]: {
        borderRadius: BorderRadiusTokens.BR5,
        labelColor: ColorTokens.Primary_100,
        bgColor: ColorTokens.White,
        borderColor: ColorTokens.Primary_100,
        paddingVertical: SizeTypeTokens.MD,
        fontSize: FontSizeTokens.SM,
        paddingHorizontal: SizeTypeTokens.XXXL,
    },
    [ButtonTypeTokens.SmallSoftFilled]: {
        borderRadius: BorderRadiusTokens.BR5,
        labelColor: ColorTokens.Primary_100,
        bgColor: ColorTokens.White,
        borderColor: ColorTokens.Primary_100,
        paddingVertical: SizeTypeTokens.SM,
        fontSize: FontSizeTokens.XS,
        paddingHorizontal: SizeTypeTokens.XL,
    },
    [ButtonTypeTokens.IconSoftFilled]: {
        borderRadius: BorderRadiusTokens.BR5,
        labelColor: ColorTokens.Primary_100,
        bgColor: ColorTokens.White,
        borderColor: ColorTokens.Primary_100,
        paddingVertical: SizeTypeTokens.LG,
        paddingHorizontal: SizeTypeTokens.LG,
    },
    [ButtonTypeTokens.LargeOutline]: {
        borderRadius: BorderRadiusTokens.BR5,
        labelColor: ColorTokens.Grey_Charcoal,
        bgColor: ColorTokens.Grey_Milk,
        borderColor: ColorTokens.Grey_Chalk,
        paddingVertical: SizeTypeTokens.LG,
        fontSize: FontSizeTokens.MD,
        paddingHorizontal: SizeTypeTokens.XXXXL,
    },
    [ButtonTypeTokens.MediumOutline]: {
        borderRadius: BorderRadiusTokens.BR5,
        labelColor: ColorTokens.Grey_Charcoal,
        bgColor: ColorTokens.Grey_Milk,
        borderColor: ColorTokens.Grey_Chalk,
        paddingVertical: SizeTypeTokens.MD,
        fontSize: FontSizeTokens.SM,
        paddingHorizontal: SizeTypeTokens.XXXL,
    },
    [ButtonTypeTokens.SmallOutline]: {
        borderRadius: BorderRadiusTokens.BR5,
        labelColor: ColorTokens.Grey_Charcoal,
        bgColor: ColorTokens.Grey_Milk,
        borderColor: ColorTokens.Grey_Chalk,
        paddingVertical: SizeTypeTokens.SM,
        fontSize: FontSizeTokens.XS,
        paddingHorizontal: SizeTypeTokens.XL,
    },
    [ButtonTypeTokens.IconOutline]: {
        borderRadius: BorderRadiusTokens.BR5,
        labelColor: ColorTokens.Primary_100,
        bgColor: ColorTokens.Transparent,
        paddingVertical: SizeTypeTokens.LG,
        borderColor: ColorTokens.Grey_200,
        paddingHorizontal: SizeTypeTokens.LG,
    },
    [ButtonTypeTokens.LargeGhost]: {
        borderRadius: BorderRadiusTokens.BR5,
        labelColor: ColorTokens.Primary_100,
        bgColor: ColorTokens.Transparent,
        paddingVertical: SizeTypeTokens.LG,
        fontSize: FontSizeTokens.MD,
        paddingHorizontal: SizeTypeTokens.XXXXL,
    },
    [ButtonTypeTokens.MediumGhost]: {
        borderRadius: BorderRadiusTokens.BR5,
        labelColor: ColorTokens.Primary_100,
        bgColor: ColorTokens.Transparent,
        paddingVertical: SizeTypeTokens.MD,
        fontSize: FontSizeTokens.SM,
        paddingHorizontal: SizeTypeTokens.XXXL,
    },
    [ButtonTypeTokens.SmallGhost]: {
        borderRadius: BorderRadiusTokens.BR5,
        labelColor: ColorTokens.Primary_100,
        bgColor: ColorTokens.Transparent,
        paddingVertical: SizeTypeTokens.SM,
        fontSize: FontSizeTokens.XS,
        paddingHorizontal: SizeTypeTokens.SM,
    },
    [ButtonTypeTokens.IconGhost]: {
        borderRadius: BorderRadiusTokens.BR5,
        labelColor: ColorTokens.Primary_100,
        bgColor: ColorTokens.Transparent,
        paddingVertical: SizeTypeTokens.SM,
        paddingHorizontal: SizeTypeTokens.SM,
    },
    [ButtonTypeTokens.LargeElevated]: {
        borderRadius: BorderRadiusTokens.BR5,
        labelColor: ColorTokens.Primary_100,
        bgColor: ColorTokens.Blue_100,
        paddingVertical: SizeTypeTokens.LG,
        fontSize: FontSizeTokens.MD,
        shadow: ShadowTypeTokens.E1,
        paddingHorizontal: SizeTypeTokens.XXXXL,
    },
    [ButtonTypeTokens.MediumElevated]: {
        borderRadius: BorderRadiusTokens.BR5,
        labelColor: ColorTokens.Primary_100,
        bgColor: ColorTokens.Blue_100,
        paddingVertical: SizeTypeTokens.MD,
        fontSize: FontSizeTokens.SM,
        shadow: ShadowTypeTokens.E1,
        paddingHorizontal: SizeTypeTokens.XXXL,
    },
    [ButtonTypeTokens.SmallElevated]: {
        borderRadius: BorderRadiusTokens.BR5,
        labelColor: ColorTokens.Primary_100,
        bgColor: ColorTokens.Blue_100,
        paddingVertical: SizeTypeTokens.SM,
        fontSize: FontSizeTokens.XS,
        shadow: ShadowTypeTokens.E1,
        paddingHorizontal: SizeTypeTokens.XL,
    },
    [ButtonTypeTokens.IconElevated]: {
        borderRadius: BorderRadiusTokens.BR5,
        labelColor: ColorTokens.Primary_100,
        bgColor: ColorTokens.Blue_100,
        paddingVertical: SizeTypeTokens.LG,
        shadow: ShadowTypeTokens.E1,
        paddingHorizontal: SizeTypeTokens.LG,
    },
};
